<template>
    <span class="loader-block"></span>
</template>

<script>
    export default {
        name: "LoaderBlock"
    }
</script>

<style scoped lang="scss">
    .loader-block {
        display: inline-block;
        border-radius: 3px;
        background-color: rgba(0, 0, 0, .15);
        background: linear-gradient(to right, #eee 20%, #ddd 50%, #eee 80%);
        background-size: 500px 100px;
        animation-name: moving-gradient;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        animation-fill-mode: forwards;
    }
    @-webkit-keyframes moving-gradient {
        0% {
            background-position: -250px 0;
        }
        100% {
            background-position: 250px 0;
        }
    }
</style>
